/* Behavior for the native landing pages (slidemvp--lp-* sections). */
(function () {
  if (window.slidemvpLp) return;
  window.slidemvpLp = true;

  function initGallery(gallery) {
    var main = gallery.querySelector('[data-lp-main]');
    if (!main) return;
    var slides = main.children;
    var thumbs = gallery.querySelectorAll('[data-lp-thumb]');
    var rail = gallery.querySelector('[data-lp-thumbs]');
    var prev = gallery.querySelectorAll('[data-lp-prev]');
    var next = gallery.querySelectorAll('[data-lp-next]');
    var count = gallery.querySelector('[data-lp-count]');

    function current() {
      return Math.round(main.scrollLeft / (main.clientWidth || 1));
    }
    function go(index) {
      var i = Math.max(0, Math.min(slides.length - 1, index));
      main.scrollTo({ left: i * main.clientWidth, behavior: 'smooth' });
    }
    // Keep the active thumbnail visible inside the scrolling rail without
    // scrolling the page.
    function reveal(thumb) {
      if (!rail || !thumb) return;
      if (rail.scrollHeight > rail.clientHeight + 1) {
        var top = thumb.offsetTop;
        if (top < rail.scrollTop) rail.scrollTop = top;
        else if (top + thumb.offsetHeight > rail.scrollTop + rail.clientHeight) rail.scrollTop = top + thumb.offsetHeight - rail.clientHeight;
      } else if (rail.scrollWidth > rail.clientWidth + 1) {
        var left = thumb.offsetLeft;
        if (left < rail.scrollLeft) rail.scrollLeft = left;
        else if (left + thumb.offsetWidth > rail.scrollLeft + rail.clientWidth) rail.scrollLeft = left + thumb.offsetWidth - rail.clientWidth;
      }
    }
    function sync() {
      var i = current();
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      reveal(thumbs[i]);
      prev.forEach(function (b) { b.disabled = i === 0; });
      next.forEach(function (b) { b.disabled = i === slides.length - 1; });
      if (count) count.textContent = 'Slide ' + (i + 1) + ' of ' + slides.length;
    }

    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    prev.forEach(function (b) {
      b.addEventListener('click', function () { go(current() - 1); });
    });
    next.forEach(function (b) {
      b.addEventListener('click', function () { go(current() + 1); });
    });
    var ticking = false;
    main.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { sync(); ticking = false; });
    });
    sync();
  }

  function addToCart(form) {
    var button = form.querySelector('[type="submit"]');
    var label = button.querySelector('[data-lp-atc-text]');
    var original = label ? label.innerHTML : '';
    var routes = window.theme && window.theme.routes;
    var url = routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add.js';

    var data = new FormData(form);
    data.append('sections', 'cart-items,cart-footer,cart-item-count,cart-live-region');
    data.append('sections_url', window.location.pathname);

    button.disabled = true;
    if (label) label.textContent = 'Adding...';

    fetch(url, {
      method: 'POST',
      body: data,
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json.status && json.status !== 200) throw new Error(json.description || 'Add to cart failed');
        var detail = { response: json };
        window.dispatchEvent(new CustomEvent('shapes:cart:afteradditem', { bubbles: true, detail: detail }));
        document.body.dispatchEvent(new CustomEvent('shapes:cart:afteradditem', { bubbles: true, detail: detail }));
        if (window.Alpine && window.Alpine.store && window.Alpine.store('modals')) {
          try { window.Alpine.store('modals').open('cart'); } catch (e) { /* drawer not available */ }
        }
        if (label) label.textContent = 'Added!';
      })
      .catch(function (err) {
        console.error(err);
        if (label) label.textContent = 'Error, try again';
      })
      .finally(function () {
        setTimeout(function () {
          if (label) label.innerHTML = original;
          button.disabled = false;
        }, 1800);
      });
  }

  function initBuyBox(root) {
    var panels = root.querySelectorAll('[data-lp-panel]');

    root.querySelectorAll('[data-lp-swatch]').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var target = swatch.getAttribute('data-lp-swatch');
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-lp-panel') !== target; });
        var shown = root.querySelector('[data-lp-panel="' + target + '"] [data-lp-swatch="' + target + '"]');
        if (shown) shown.focus({ preventScroll: true });
      });
    });

    root.querySelectorAll('[data-lp-gallery]').forEach(initGallery);

    root.querySelectorAll('[data-lp-qty]').forEach(function (qty) {
      var input = qty.querySelector('input');
      qty.querySelectorAll('[data-lp-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var next = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-lp-step'), 10);
          input.value = Math.max(1, next);
        });
      });
    });

    root.querySelectorAll('form[data-lp-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart(form);
      });
    });
  }

  function initReviews(root) {
    var track = root.querySelector('[data-lp-track]');
    var cards = track.querySelectorAll('.lp-review');
    var steps = root.querySelectorAll('[data-lp-review-step]');
    var dotsWrap = root.querySelector('[data-lp-review-dots]');
    var dots = [];

    function cardStep() {
      return cards[0] ? cards[0].getBoundingClientRect().width + 15 : 320;
    }
    function active() {
      return Math.min(cards.length - 1, Math.round(track.scrollLeft / cardStep()));
    }
    function sync() {
      var i = active();
      var end = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      dots.forEach(function (d, n) { d.classList.toggle('is-active', end ? n === dots.length - 1 : n === i); });
      steps.forEach(function (b) {
        if (parseInt(b.getAttribute('data-lp-review-step'), 10) < 0) b.classList.toggle('is-dim', i === 0);
      });
    }

    if (dotsWrap) {
      cards.forEach(function (card, n) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Show review ' + (n + 1));
        dot.addEventListener('click', function () { track.scrollTo({ left: n * cardStep(), behavior: 'smooth' }); });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }
    steps.forEach(function (b) {
      b.addEventListener('click', function () {
        var n = cards.length;
        var target = (active() + parseInt(b.getAttribute('data-lp-review-step'), 10) + n) % n;
        track.scrollTo({ left: target * cardStep(), behavior: 'smooth' });
      });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { sync(); ticking = false; });
    });
    sync();

    root.querySelectorAll('[data-lp-video]').forEach(function (tile) {
      var video = tile.querySelector('video');
      var mute = tile.querySelector('[data-lp-mute]');
      tile.querySelector('[data-lp-play]').addEventListener('click', function () {
        if (video.paused) video.play(); else video.pause();
      });
      video.addEventListener('click', function () { video.pause(); });
      video.addEventListener('play', function () { tile.classList.add('is-playing'); });
      video.addEventListener('pause', function () { tile.classList.remove('is-playing'); });
      mute.addEventListener('click', function () {
        video.muted = !video.muted;
        tile.classList.toggle('is-unmuted', !video.muted);
      });
    });
    var more = root.querySelector('[data-lp-more]');
    if (more) {
      more.addEventListener('click', function () {
        root.classList.remove('is-collapsed');
        more.parentElement.hidden = true;
      });
    }
  }

  function initCompare(scroller) {
    var segs = scroller.parentElement.parentElement.querySelectorAll('[data-lp-compare-seg]');
    if (!segs.length) return;
    scroller.addEventListener('scroll', function () {
      var max = scroller.scrollWidth - scroller.clientWidth;
      var i = max > 0 && scroller.scrollLeft > max / 2 ? 1 : 0;
      segs.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
    });
  }

  function initFaq(root) {
    var items = root.querySelectorAll('details');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) { if (other !== item) other.open = false; });
      });
    });
  }

  function init(scope) {
    scope.querySelectorAll('[data-lp-buy]').forEach(initBuyBox);
    scope.querySelectorAll('[data-lp-reviews]').forEach(initReviews);
    scope.querySelectorAll('[data-lp-faq]').forEach(initFaq);
    scope.querySelectorAll('[data-lp-compare]').forEach(initCompare);
    scope.querySelectorAll('[data-lp-scroll]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function start() { init(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
